import React, { useContext } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Header, Icon, Segment, Table } from 'semantic-ui-react'
import { CoolFarmOptionsContext } from '../..'
import { FormFields } from '~/components/FormFields'

const BeddingTypes:React.FC = () => {
  const { control } = useFormContext()
  const { t } = useTranslation()

  const options = useContext(CoolFarmOptionsContext)

  const { fields: beddingFields, append: appendBedding, remove: removeBedding } = useFieldArray({
    control,
    name: 'beddingTypes',
    keyName: 'key'
  })

  const beddingTypeOptions = options?.beddingTypes?.map(bedding => ({
    key: bedding.id,
    value: bedding.id,
    text: bedding.label
  })) || []

  const beddingUnits = options?.beddingUnits?.map(unit => ({
    key: unit.key,
    value: unit.key,
    text: unit.label
  })) || []

  return (
    <>
      <Header attached='top' block>{t('Bedding Types')}</Header>
      <Segment attached>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('Bedding Type')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Bedding quantity')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Unit')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {beddingFields.map((field, index) => (
              <Table.Row key={field.key}>
                <Table.Cell>
                  <FormFields.Select
                    control={control}
                    name={`beddingTypes[${index}].id`}
                    options={beddingTypeOptions}
                    placeholder={t('Select bedding type')}
                    rules={{ required: t('Required') }}
                    withoutLabel
                    noErrorMessage
                />
                </Table.Cell>
                <Table.Cell>
                  <FormFields.Input
                    control={control}
                    name={`beddingTypes[${index}].amount`}
                    placeholder={t('Amount')}
                    rules={{ required: t('Required') }}
                    typeInput='controled'
                    allowDecimals
                    decimalScale={2}
                    withoutAsterisk
                    noErrorMessage
                />
                </Table.Cell>
                <Table.Cell>
                  <FormFields.Select
                    control={control}
                    name={`beddingTypes[${index}].amountUnit`}
                    options={beddingUnits}
                    placeholder={t('Unit')}
                    rules={{ required: t('Required') }}
                    withoutLabel
                    noErrorMessage
                />
                </Table.Cell>
                <Table.Cell textAlign='center'>
                  <Icon
                    name='trash'
                    color='red'
                    style={{ cursor: 'pointer', fontSize: '1.2em' }}
                    onClick={() => removeBedding(index)}
                />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            type='button'
            style={{ color: 'white' }}
            icon='plus'
            content={t('Add Bedding Type')}
            onClick={() => appendBedding({
              id: null,
              amount: null,
              amountUnit: null
            })}
      />
        </div>
      </Segment>
    </>
  )
}
export default BeddingTypes